import 'isomorphic-fetch';

// set by webpack on build
const baseUrl = (process.env.REACT_APP_API_BASE || 'http://localhost:8888/server')+"/app";

const defaultHeaders = new Headers();
defaultHeaders.append('Accept', 'application/json');
const jsonHeaders = new Headers();
jsonHeaders.append('Accept', 'application/json');
jsonHeaders.append('Content-Type', 'application/json');

const baseRequest = {
    method:'POST',
    headers:defaultHeaders,
    cache:'default',
    credentials:'include',
    mode:'cors'
};
const baseJsonRequest = {
    method:'POST',
    headers:jsonHeaders,
    cache:'default',
    credentials:'include',
    mode:'cors'
};
function getJsonPromise(url, extra = {}) {
    let request = new Request(baseUrl+url, {...extra, ...baseJsonRequest, method:'GET'});
    return returnJsonPromise(request);
}
function postJsonPromise(url, extra = {}) {
    let request = new Request(baseUrl+url, {...extra, ...baseJsonRequest, method:'POST'});
    return returnJsonPromise(request);
}
function patchJsonPromise(url, extra = {}) {
    let request = new Request(baseUrl+url, {...extra, ...baseJsonRequest, method:'PATCH'});
    return returnJsonPromise(request);
}
function postFormJsonPromise(url, extra = {}) {
    let request = new Request(baseUrl+url, {...extra, ...baseRequest, method:'POST'});
    return returnJsonPromise(request);
}
function returnJsonPromise(request) {
    return fetch(request)
    .then((r) => {
        if ( r.ok ) {
            return r.json();
        } else {
            // Handle errors; Two types, wrapped by us according to jsend,
            // and spring errors on incorrect arguments etc
            console.error("Got non 2xx status code: "+r);

            return r.text().then(function(value) {
                value = value.trim();
                let jsendResponse = null;
                try {
                    jsendResponse = JSON.parse(value);
                } catch(e) {
                    console.warn('Got non JSON response: '+value);
                    const jsonError = {status:'error', code:r.status, message:value.length > 0? value: r.statusText};
                    return Promise.reject(jsonError);
                }
                return Promise.reject(jsendResponse);
            });
        }
    }).catch(function(error) {
        console.error(error);
        if ( error instanceof Error ) {
            // Network error - basically the only error fetch will throw
            const jsonError = {status:'error', code:-1,  message:error.message};
            return Promise.reject(jsonError);
        } else {
            return Promise.reject(error);
        }

    })


}

const api = {
    login: (username, password) => {
        let formdata = new FormData();
        formdata.append('username', username);
        formdata.append('password', password);
        return postFormJsonPromise('/login', {body: formdata});

    },
    logout: () => {
        let request = new Request(baseUrl+'/logout', { ...baseRequest, method:'GET'});
        return fetch(request)
        .then(() => { return null; })
    },
    getAccount: () => {
        return getJsonPromise('/account');
    },
    getItems: () => {
        return getJsonPromise('/item');
    },
    patchItems: (patch) => {
        console.log('Patching items:',  JSON.stringify(patch, null, 2));
        return patchJsonPromise('/item/', {body: JSON.stringify(patch)});
    },
    getSearchItems: (query) => {
        return getJsonPromise('/items?q='+query);
    },
    getWorkSessionItems: (workSessionId) => {
        return getJsonPromise('/worksession/'+workSessionId+'/items');
    },
    getAssignees: () => {
        return getJsonPromise('/assignee');
    },
    patchAssignees: (patch) => {
        console.log('Patching assignees:',  JSON.stringify(patch, null, 2));
        return patchJsonPromise('/assignee/', {body: JSON.stringify(patch)});
    },
    getCurrentWorkSession: (id) => {
        return getJsonPromise('/worksession/'+id);
    },
    createWorkSession: (templateId) => {
        return postJsonPromise('/worksession/', {body: JSON.stringify({templateId: templateId})});
    },
    patchWorkSession: (id, patch) => {
        console.log('Patching workSession: '+id,  JSON.stringify(patch, null, 2));
        return patchJsonPromise('/worksession/'+id, {body: JSON.stringify(patch)});
    },
    getWorkSessions: () => {
        return getJsonPromise('/worksession');
    },
    getWorkSessionTemplates: () => {
        return getJsonPromise('/worksessiontemplate');
    },
};
export default api;


// WEBPACK FOOTER //
// ./src/model/apiClient.js